/**
 * 配置模块统一导出
 */

export {
  getMigrationConfig,
  setMigrationConfig,
  shouldUseV2,
  enableEventV2,
  enablePageV2,
  enableGlobalV2,
  disableEventV2,
  disableGlobalV2,
  defaultMigrationConfig,
} from "./migration";

export type { MigrationConfig } from "./migration";

export {
  PAGE_CONTEXTS,
  getPageContextTypes,
  needsContext,
  isSearchPage,
  isDetailPage,
} from "./pageContexts";
